import { MorningMeeting } from "../MorningMeetings/MorningMeetings.types";

export interface MorningMeetingDetailsDto extends MorningMeeting {
  agenda_items: AgendaItem[];
  files: MorningMeetingFile[];
  contains_unconfirmed_notes: boolean;
  contains_confirmed_notes: boolean;
}

export type MorningMeetingFileType = "TRANSCRIPT" | "MEETING_NOTES" | "RECORDING";

export type ZoomFetchFileType = "TRANSCRIPT";

export const ZOOM_FETCH_FILE_TYPE_LABELS: Record<ZoomFetchFileType, string> = {
  TRANSCRIPT: "Transcript",
};

export interface MorningMeetingFile {
  id: string;
  name: string;
  type: MorningMeetingFileType;

  archived: boolean;
  deleted: boolean;
  created: string,
  created_by: string,
  updated: string,
  updated_by: string
}

export interface AgendaItem {
  id: string;
  company: AgendaItemCompany;
  files: AgendaItemFile[];
  order: number;
  morning_meeting_id: string;
  speaker: string;
  speaker_name: string;
  topic: string;
  topic_classifier: TopicClassifier;
  archived: boolean;
  deleted: boolean;
  created: string,
  created_by: string,
  updated: string,
  updated_by: string
}

export interface AgendaItemCompany {
  id: string;
  name: string;
  bq: number;
  mq: number;
  fair_value: number | null;
  fair_value_upside_pct: string | null;
  portfolio_weight: string | null;
}

export interface AgendaItemFile {
  id: string;
  name: string;

  archived: boolean;
  deleted: boolean;
  created: string,
  created_by: string,
  updated: string,
  updated_by: string
}

export interface TopicClassifier {
  id: string;
  value: string;
}
